<template>
    <div class="dataToConfirmBox">
        <SJMLoading v-if="isLoading"></SJMLoading>
        <!-- 入库数据 -->
        <div class="toStoraged">
            <div class="booking">
                <span class="bookingTitle">{{$t('message.bookingData')}}</span>
                <span><em class="pcsData">{{bookingData.pieces}}</em><em class="unit">PCS</em></span>
                <span><em class="kgsData">{{bookingData.weight}}</em><em class="unit">KGS</em></span>
                <span><em class="cbmData">{{bookingData.volume}}</em><em class="unit">CBM</em></span>
                <span><em class="unitData">1:{{bookingData.proportion}}</em><em class="unit">{{$t('message.proportion')}}</em></span>
                <span>{{$t('message.cargoType')}}{{$t('message.$colon')}}<em>{{$cargoType(bookingFee.cargoType)}}</em></span>
                <span>{{$t('message.foamingRatio')}}{{$t('message.$colon')}}<em>{{bookingFee.bubbleRatio}}</em></span>
            </div>
            <div class="bookingTable">
                <table>
                    <thead>
                        <tr>
                            <th>{{$t('message.index')}}</th>
                            <th>{{$t('message.intoCabinNumber')}}</th>
                            <th width="13%">{{$t('message.intoCabinTime')}}</th>
                            <th>{{$t('message.pieces')}} PCS</th>
                            <th>{{$t('message.weight')}} KGS</th>
                            <th>{{$t('message.volume')}} CBM</th>
                            <th>{{$t('message.goodsSize')}} CM</th>
                            <th>{{$t('message.packageType')}}</th>
                            <th>{{$t('message.boxStatus')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(intoCabinItem,index) in intoCabinInfo" :key="index">
                            <td>{{index>9?index+1:`0${index+1}`}}</td>
                            <td>
                                <span>{{ intoCabinItem.number }}</span>
                            </td>
                            <td>
                                <span>{{ intoCabinItem.date }}</span>
                            </td>
                            <td>
                                <span>{{ intoCabinItem.pieces }}</span>
                            </td>
                            <td>
                                <span>{{ intoCabinItem.weight }}</span>
                            </td>
                            <td>
                                <span>{{ intoCabinItem.volume }}</span>
                            </td>
                            <td>
                                <p v-for="(item, index) in intoCabinItem.goodsInfo"
                                   :key="index"
                                   :title="goodsInfoTitle(item)">
                                    {{item.length || '--'}}*{{item.width || '--'}}*{{item.high || '--'}}/{{item.pieces ||
                                        '--'}}
                                </p>
                            </td>
                            <td>
                                <p v-for="(item, index) in intoCabinItem.goodsInfo"
                                   :key="index"
                                   :title="item.packageMethod">
                                    {{item.packageMethod}}
                                </p>
                            </td>
                            <td>
                                <p v-for="(item, index) in intoCabinItem.goodsInfo"
                                   :key="index"
                                   :class="{'broken': item.boxStatus!=='正常'}"
                                   :title="item.boxStatus">
                                    {{item.boxStatus}}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="storageTotal">
                <p>{{$t('message.intoCabin')}}{{$t('message.$space')}}TOTAL</p>
                <div class="storagePanel">
                    <div>
                        <span class="bookingTitle">{{$t('message.intoCabin')}}{{$t('message.$space')}}{{$t('message.pieces')}}：</span>
                        <span><em class="pcsData intoCabin">{{intoCabinTotal.pieces}}</em><em
                                class="unit">PCS</em></span>
                    </div>
                    <div>
                        <span class="bookingTitle">{{$t('message.intoCabin')}}{{$t('message.$space')}}{{$t('message.weight')}}：</span>
                        <span><em class="kgsData intoCabin">{{intoCabinTotal.weight}}</em><em
                                class="unit">KGS</em></span>
                    </div>
                    <div>
                        <span class="bookingTitle">{{$t('message.intoCabin')}}{{$t('message.$space')}}{{$t('message.volume')}}：</span>
                        <span><em class="cbmData intoCabin">{{intoCabinTotal.volume}}</em><em
                                class="unit">CBM</em></span>
                    </div>
                    <div>
                        <span><em class="unit">{{$t('message.goodsProportion')}}：</em></span>
                        <span><em class="unitData intoCabin">1:{{intoCabinTotal.proportion}}</em></span>
                    </div>
                </div>
                <div class="storageConfirmBtn">
                    <el-button v-if="confirmTypeGroup.intoCabinType==='0'"
                               type="primary"
                               size="medium"
                               :class="{animation:true,isSelf: intoCabinDataType === '1',animation1: intoCabinDataType === '1'}"
                               @click="intoCabinConfirm">
                        <span v-if="intoCabinDataType === '0'">{{$t('message.platformConfirm')}}</span>
                        <span v-if="intoCabinDataType === '1'">{{$t('message.selfConfirm')}}</span>
                    </el-button>
                    <el-button v-else
                               type="info"
                               disabled="disabled"
                               size="medium">
                        {{$t('message.intoCabinConfirmed')}}
                    </el-button>
                </div>
            </div>
        </div>
        <!-- 制单数据 -->
        <div v-if="confirmTypeGroup.intoCabinType==='1'" class="makeDoc">
            <div class="declareWeight">
                <span>{{$t('message.customsClearanceWeight')}}：</span>
                <span><em class="kgsData">{{clearanceWeight.customsClearanceWeight}}</em><em
                        class="unit">KGS</em></span><br/>
                <span class="tips">{{$t('message.tip')}}：{{$t('message.minCustomsClearanceWeight')}}&ensp;<em>{{clearanceWeight.minCustomsClearanceWeight}}</em>&ensp;KGS，{{$t('message.mayAddExternalFee')}}</span>
            </div>
            <div class="scheme">
                <ul ref="freightPlan">
                    <li>
                        <div class="bookingFreight">
                            <div class="title">
                                <i class="iconfont icon-50"></i>
                                <span>{{$t('message.bookingFee')}}</span>
                            </div>
                            <div class="cargoTypeBubbleRatio">
                                <div>
                                    <span>{{$t('message.cargoType')}}{{$t('message.$colon')}}</span>
                                    <span class="cargoTypeBubbleRatioValue">{{$cargoType(bookingFee.cargoType)}}</span>
                                </div>
                                <div class="bubbleRatio">
                                    <span>{{$t('message.foamingRatio')}}{{$t('message.$colon')}}</span>
                                    <span class="cargoTypeBubbleRatioValue">{{bookingFee.bubbleRatio}}</span>
                                </div>
                            </div>
                            <table class="feeTable">
                                <tr>
                                    <th>{{$t('message.feeName')}}</th>
                                    <th>{{$t('message.unitPrice')}}</th>
                                    <th>{{$t('message.quantity')}}</th>
                                    <th>{{$t('message.amount')}}</th>
                                </tr>
                                <tr v-for="(item, index) in bookingFee.billList" :key="index">
                                    <td>{{item.feeName}}</td>
                                    <td>{{$currencyAbbr(currencyType)}}{{item.settleUnitPrice}}</td>
                                    <td>{{item.settleCount}}</td>
                                    <td>{{$currencyAbbr(currencyType)}}{{item.totalAmount}}</td>
                                </tr>
                            </table>
                            <div class="total">
                                <span>TOTAL: </span>
                                <span class="totalCost">
                                    {{$currencyAbbr(currencyType)}}{{computedBillListTotal(bookingFee.billList)}}
                                </span>
                            </div>
                        </div>
                    </li>
                    <li :class="{selected: isSelected.intoCabinFee}"
                        @click="selectSchemeAjax('intoCabinFee', 0)">
                        <div class="freightType">
                            <p class="title">
                                <i class="iconfont icon-50"></i>
                                <span>{{$t('message.intoCabinFee')}}</span>
                            </p>
                            <div class="cargoTypeBubbleRatio">
                                <div>
                                    <span>{{$t('message.cargoType')}}{{$t('message.$colon')}}</span>
                                    <span class="cargoTypeBubbleRatioValue">
                                        {{$cargoType(intoCabinFee.cargoType)}}
                                    </span>
                                </div>
                                <div class="bubbleRatio">
                                    <span>{{$t('message.foamingRatio')}}{{$t('message.$colon')}}</span>
                                    <span class="cargoTypeBubbleRatioValue">
                                        {{intoCabinFee.bubbleRatio}}
                                    </span>
                                </div>
                            </div>
                            <table class="feeTable">
                                <tr>
                                    <th>{{$t('message.feeName')}}</th>
                                    <th>{{$t('message.unitPrice')}}</th>
                                    <th>{{$t('message.quantity')}}</th>
                                    <th>{{$t('message.amount')}}</th>
                                </tr>
                                <tr v-for="(item, index) in intoCabinFee.billList" :key="index">
                                    <td>{{item.feeName}}</td>
                                    <td>{{$currencyAbbr(currencyType)}}{{item.settleUnitPrice}}</td>
                                    <td>{{item.settleCount}}</td>
                                    <td>{{$currencyAbbr(currencyType)}}{{item.totalAmount}}</td>
                                </tr>
                            </table>
                            <div class="total">
                                <span>TOTAL: </span>
                                <span class="totalCost">
                                    {{$currencyAbbr(currencyType)}}{{computedBillListTotal(intoCabinFee.billList)}}
                                </span>
                            </div>
                            <p class="freightTips fee">{{intoCabinFee.tips}}</p>
                            <div class="schemeOption">
                                {{$t('message.schemeOne')}}
                            </div>
                        </div>
                    </li>
                    <li :class="{selected: isSelected.optimizationFee}"
                        @click="selectSchemeAjax('optimizationFee', 1)">
                        <div class="freightType">
                            <p class="title">
                                <i class="iconfont icon-50"></i>
                                <span>{{$t('message.optimizationFee')}}</span>
                            </p>
                            <div class="cargoTypeBubbleRatio">
                                <div>
                                    <span>{{$t('message.cargoType')}}{{$t('message.$colon')}}</span>
                                    <span class="cargoTypeBubbleRatioValue">
                                        {{$cargoType(optimizationFee.cargoType)}}
                                    </span>
                                </div>
                                <div class="bubbleRatio">
                                    <span>{{$t('message.foamingRatio')}}{{$t('message.$colon')}}</span>
                                    <span class="cargoTypeBubbleRatioValue">
                                        {{optimizationFee.bubbleRatio}}
                                    </span>
                                </div>
                            </div>
                            <table class="feeTable">
                                <tr>
                                    <th>{{$t('message.feeName')}}</th>
                                    <th>{{$t('message.unitPrice')}}</th>
                                    <th>{{$t('message.quantity')}}</th>
                                    <th>{{$t('message.amount')}}</th>
                                </tr>
                                <tr v-for="(item, index) in optimizationFee.billList" :key="index">
                                    <td>{{item.feeName}}</td>
                                    <td>{{$currencyAbbr(currencyType)}}{{item.settleUnitPrice}}</td>
                                    <td>{{item.settleCount}}</td>
                                    <td>{{$currencyAbbr(currencyType)}}{{item.totalAmount}}</td>
                                </tr>
                            </table>
                            <div class="total">
                                <span>TOTAL: </span>
                                <span class="totalCost">
                                    {{$currencyAbbr(currencyType)}}{{computedBillListTotal(optimizationFee.billList)}}
                                </span>
                            </div>
                            <p class="freightTips fee">{{optimizationFee.tips}}</p>
                            <div class="schemeOption">
                                {{$t('message.schemeTwo')}}
                            </div>
                            <img src="@/assets/img/personalCenter/operationCenter/cargoQuery/exportBusiness/dataToConfirm/optimalIcon.png"/>
                        </div>
                    </li>
                </ul>
                <div class="line"></div>
            </div>
            <!-- 制单数据确认 -->
            <div v-if="confirmTypeGroup.intoCabinType==='1' && confirmTypeGroup.freightFeeType==='1'" class="docData">
                <p>{{$t('message.makeBillData')}}</p>
                <div class="docDataBox">
                    <div>
                        <span class="bookingTitle">{{$t('message.makeDoc')}}{{$t('message.$space')}}{{$t('message.pieces')}}：</span>
                        <span class="bookingValue"><em class="pcsData fee">{{makeBillData.pieces}}</em><em class="unit">PCS</em></span>
                    </div>
                    <div>
                        <span class="bookingTitle">{{$t('message.practical')}}{{$t('message.$space')}}{{$t('message.weight')}}：</span>
                        <span class="bookingValue"><em class="dgsData fee">{{makeBillData.weight}}</em><em class="unit">KGS</em></span>
                    </div>
                    <div>
                        <span class="bookingTitle">{{$t('message.charging')}}{{$t('message.$space')}}{{$t('message.weight')}}：</span>
                        <span class="bookingValue"><em class="kgsData fee">{{makeBillData.feeWeight}}</em>
                            <em class="unit">KGS</em></span>
                    </div>
                    <div>
                        <span>{{$t('message.makeDoc')}}{{$t('message.$space')}}{{$t('message.volume')}}：</span>
                        <span class="bookingValue"><em class="cbmData fee">{{makeBillData.volume}}</em><em class="unit">CBM</em></span>
                    </div>
                    <div>
                        <span>{{$t('message.makeDoc')}}{{$t('message.$space')}}{{$t('message.proportion')}}：</span>
                        <span class="bookingValue"><em class="unitData fee">{{makeBillData.proportion}}</em></span>
                    </div>
                </div>
                <div class="docDataConfirmBtn">
                    <div ref="billDataConfirm">
                        <el-button v-if="confirmTypeGroup.makeBillType==='0'"
                                   type="primary"
                                   class="animation"
                                   size="medium"
                                   @click="makeBillDataAjax">{{$t('message.makeBillConfirm')}}
                        </el-button>
                        <el-button v-else
                                   type="info"
                                   disabled="disabled"
                                   size="medium">
                            {{$t('message.makeBillConfirmed')}}
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 入库数据确认提醒弹窗 -->
        <el-dialog :visible.sync="intoCabinConfirmTipsDialog"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false"
                   :width="$i18n.locale==='zhCHS' ? '390px' : '720px'"
                   :title="$t('message.intoCabinConfirmTips')">
            <el-collapse v-model="intoCabinConfirmTipsActive">
                <!-- 货型变化提示 -->
                <el-collapse-item
                        v-if="intoCabinConfirmCallBack.goodsType.nowType !== intoCabinConfirmCallBack.goodsType.oldType"
                        name="goodsTypeTips">
                    <template slot="title">
                        <b>{{$t('message.goodsTypeTips')}}</b>
                    </template>
                    <div>
                        <!-- 托盘散货转换提醒 -->
                        <p>
                            <!-- 0-托盘转散货 1-散货转托盘 -->
                            {{ intoCabinConfirmCallBack.goodsType.nowType === '0' ? $t('message.tray2bulk') :
                                $t('message.bulk2tray')}}{{$t('message.$comma')}}{{$t('message.isCarryOutIntoCabinDataConfirm')}}{{$t('message.$qm')}}
                        </p>
                        <!-- 新老货型 -->
                        <p>
                            <span :style="`${$i18n.locale==='zhCHS' ? 'width: 130px;' : 'width: 330px;'}margin-right: 20px;display: inline-block;`">
                                {{$t('message.oldPrice')}}
                                {{$t('message.$colon')}}
                                {{$currencyAbbr(this.currencyType)}}
                                {{intoCabinConfirmCallBack.goodsTypePrice.oldPrice}}
                            </span>
                            <span>{{$t('message.nowPrice')}}{{$t('message.$colon')}}</span>
                            <span :style="{color: intoCabinConfirmCallBack.goodsTypePrice.nowPrice !== intoCabinConfirmCallBack.goodsTypePrice.oldPrice ? 'red' : 'black'}">{{$currencyAbbr(currencyType)}}{{intoCabinConfirmCallBack.goodsTypePrice.nowPrice}}</span>
                        </p>
                        <!-- 新老分泡比 -->
                        <p>
                            <span :style="`${$i18n.locale==='zhCHS' ? 'width: 130px;' : 'width: 330px;'}margin-right: 20px;display: inline-block;`">
                                {{$t('message.oldBubbleRatio')}}
                                {{$t('message.$colon')}}
                                {{intoCabinConfirmCallBack.goodsTypeBubbleRatio.oldBubbleRatio}}
                            </span>
                            <span>{{$t('message.nowBubbleRatio')}}{{$t('message.$colon')}}</span>
                            <span :style="{color: intoCabinConfirmCallBack.goodsTypeBubbleRatio.nowBubbleRatio !== intoCabinConfirmCallBack.goodsTypeBubbleRatio.oldBubbleRatio ? 'red' : 'black'}">{{this.intoCabinConfirmCallBack.goodsTypeBubbleRatio.nowBubbleRatio}}</span>
                        </p>
                    </div>
                </el-collapse-item>
                <!-- 超限提示 -->
                <el-collapse-item v-if="confirmTypeGroup.exceedType !== '0'" name="exceedTypeTips">
                    <template slot="title">
                        <b>{{$t('message.exceedTypeTips')}}</b>
                    </template>
                    <div>{{msgList[confirmTypeGroup.exceedType]}}</div>
                </el-collapse-item>
                <!-- 加重提示 -->
                <el-collapse-item v-if="confirmTypeGroup.addWeightType !== '0'" name="weightTips">
                    <template slot="title">
                        <b>{{$t('message.weightTips')}}</b>
                    </template>
                    <div>{{$t('message.weightTipsText')}}</div>
                </el-collapse-item>
            </el-collapse>
            <div v-if="confirmTypeGroup.exceedType !== '0'" style="margin-top: 17px;">
                <el-radio v-model="confirmBtnType" 
                          style="margin-left: 0;margin-right: 0;width: 100%;height: 40px;padding: 0;display: flex;align-items: center;padding-left: 10px;white-space: pre;"
                          label="2" 
                          size="medium" 
                          border>自行调整货物入库数据，调整完后再确认</el-radio>
                <el-radio v-model="confirmBtnType" 
                          style="margin-left: 0;margin-right: 0;width: 100%;height: 40px;padding: 0;display: flex;align-items: center;padding-left: 10px;white-space: pre;margin-top: 16px;"
                          label="1" 
                          size="medium" 
                          border>按现在的入库数据确认，需要供应商审核</el-radio>

            </div>
            <div class="intoCabinConfirmTipsButtonBox">
                <el-button v-if="['1','2'].includes(confirmBtnType) || confirmTypeGroup.exceedType === '0'" 
                           type="primary" 
                           @click="intoCabinDialogConfirm">
                    {{ confirmTypeGroup.exceedType === '0' ? '确认' : confirmBtnType === '2' ? '稍后确认' : '现在确认' }}
                </el-button>
            </div>
        </el-dialog>
        <!-- 选择直单分单弹框 -->
        <el-dialog :visible.sync="dialogVisible"
                   custom-class="dialogLoad"
                   :close-on-click-modal="false"
                   width="314px"
                   top="20%">
            <div class="choice">
                <el-radio-group v-model="radio" class="radio">
                    <div @click="postSelectAirWaybillTypeData('1')">
                        <el-radio-button label="直单" 
                                         class="choiceBtn"></el-radio-button>
                    </div>
                    <el-radio-button label="分单" 
                                     class="choiceBtn2"></el-radio-button>
                </el-radio-group>
            </div>
            <el-input v-if="radio === '分单'"
                      v-model.trim="reinsuranceNumber"
                      class="choiceInput"
                      placeholder="请填写分单份数"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="radio === '分单'"
                           type="primary"
                           @click="postSelectAirWaybillTypeData('0')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'DataToConfirm',
        data() {
            return {
                isLoading: false,
                // 确认状态
                confirmTypeGroup: {
                    intoCabinType: '',// 入库数据确认标志 0-N、1-Y
                    exceedType: '',// 入库数据超出标志 查看枚举值（文件底部）
                    freightFeeType: '',// 运费方案确认标志 0-N、1-Y
                    makeBillType: ''// 制单数据确认标志 0-N、1-Y
                },
                confirmBtnType: '',// 入库超出后客户选择的确认情况
                // 入库数据确认信息
                intoCabinInfo: [],
                // 超限提示文字数组
                msgList: {
                    1: !this.$overseasType ? this.$t('message.exceedTypeMsg1') : this.$t('message.exceedTypeMsgEN1'),
                    2: !this.$overseasType ? this.$t('message.exceedTypeMsg2') : this.$t('message.exceedTypeMsgEN2'),
                    3: !this.$overseasType ? this.$t('message.exceedTypeMsg3') : this.$t('message.exceedTypeMsgEN3'),
                    4: !this.$overseasType ? this.$t('message.exceedTypeMsg4') : this.$t('message.exceedTypeMsgEN4'),
                    5: !this.$overseasType ? this.$t('message.exceedTypeMsg5') : this.$t('message.exceedTypeMsgEN5'),
                    6: !this.$overseasType ? this.$t('message.exceedTypeMsg6') : this.$t('message.exceedTypeMsgEN6'),
                },
                intoCabinConfirmTipsDialog: false, // 入库数据确认提醒弹窗
                intoCabinConfirmTipsActive: ['goodsTypeTips', 'exceedTypeTips', 'weightTips'], // 初始化提醒弹窗激活的面板
                // 入库数据确认回调
                intoCabinConfirmCallBack: {
                    // 货型变更
                    goodsType: {
                        oldType: '',// 原有货型 0-散货、1-托盘
                        nowType: '',// 当前货型 0-散货、1-托盘
                    },
                    // 货型变更分泡比提醒
                    goodsTypeBubbleRatio: {
                        oldBubbleRatio: '',// 分泡比例（具体比例，如：2/8 || 不分泡）
                        nowBubbleRatio: '',// 分泡比例（具体比例，如：2/8 || 不分泡）
                    },
                    // 货型变更价格提醒
                    goodsTypePrice: {
                        oldPrice: '',// 原有价格
                        nowPrice: '',// 当前价格
                    },
                },
                // 订舱数据
                bookingData: {
                    pieces: '',// 件数（无数据返回空字符串）
                    weight: '',// 重量（无数据返回空字符串）
                    volume: '',// 体积（无数据返回空字符串）
                    proportion: '',// 比重（无数据返回空字符串）
                },
                // 入库合计
                intoCabinTotal: {
                    pieces: '',// 件数（无数据返回空字符串）
                    weight: '',// 重量（无数据返回空字符串）
                    volume: '',// 体积（无数据返回空字符串）
                    proportion: '',// 比重（无数据返回空字符串）
                },
                // 报关信息
                clearanceWeight: {
                    customsClearanceWeight: '',
                    minCustomsClearanceWeight: ''
                },
                // 订舱运费
                bookingFee: {
                    cargoType: '',// 货型 0-散货、1-托盘
                    bubbleRatio: '',// 分泡比例（具体比例，如：2/8 || 不分泡）
                    // 费用列表
                    billList: [],
                },
                // 入库运费
                intoCabinFee: {
                    cargoType: '',// 货型 0-散货、1-托盘
                    bubbleRatio: '',// 分泡比例（具体比例，如：2/8 || 不分泡）
                    // 费用列表
                    billList: [],
                    tips: ''// tips
                },
                // 优化运费
                optimizationFee: {
                    cargoType: '',// 货型 0-散货、1-托盘
                    bubbleRatio: '',// 分泡比例（具体比例，如：2/8 || 不分泡）
                    // 费用列表
                    billList: [],
                    tips: ''// tips
                },
                // 产品类型
                productType: '',
                // 入库运费方案
                freightFeePlan: '',
                // 方案是否选中
                isSelected: {
                    intoCabinFee: false,
                    optimizationFee: false
                },
                // 制单数据
                makeBillData: {
                    pieces: '--',// 件数（无数据返回空字符串）
                    weight: '--',// 重量（无数据返回空字符串）
                    feeWeight: '--',// 计费重量（无数据返回空字符串）
                    volume: '--',// 体积（无数据返回空字符串）
                    proportion: '--'// 比重（无数据返回空字符串）
                },
                // 托单号
                orderBillCode: '',
                // 币种
                currencyType: '',

                // 进入制单页面
                radio: '',// 分单直单选择
                reinsuranceNumber: '',// 分单数量
                dialogVisible: false,// 选择直单分单弹框
                selectAirWaybillType: '',// 是否选择制单类型 0-N、1-Y
                maxHouseBillNumber: '',// 最大分单数（无返回空字符串）
                intoCabinDataType: '', // 入库数据类型 0-平台提供、1-用户自提供
            };
        },
        created() {
            this.getBillsDataAjax();
            this.getSelectAirWaybillTypeData();
        },
        methods: {
            // 页面初始渲染ajax
            getBillsDataAjax() {
                this.orderBillCode = this.$route.query.orderBillCode;
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/DataToConfirmHandler.ashx',
                    data: {
                        act: 'getBillingDataConfirmDataV2',// 获取 制单数据确认数据V2
                        orderBillCode: this.orderBillCode
                    },
                    errCallback: () => {
                        this.$router.push('/personalCenter/PersonalCenterMain');
                    },
                    beforeSend: () => {
                        this.isLoading = true;
                    },
                    success: (res) => {
                        let data = res.success;
                        this.confirmTypeGroup = data.confirmTypeGroup;
                        this.intoCabinDataType = data.intoCabinDataType;      
                        // ----------入库数据确认-----------
                        this.intoCabinInfo = data.intoCabinDataList;
                        this.bookingData = data.bookingData;
                        this.intoCabinTotal = data.intoCabinTotal;
                        // ----------选择运费方案-----------
                        this.clearanceWeight.customsClearanceWeight = data.customsClearanceWeight;
                        this.clearanceWeight.minCustomsClearanceWeight = data.minCustomsClearanceWeight;
                        this.bookingFee = data.bookingFee;
                        this.intoCabinFee = data.intoCabinFee;
                        this.optimizationFee = data.optimizationFee;
                        this.productType = data.productType;
                        // 币种
                        this.currencyType = data.currencyType;
                        if (this.confirmTypeGroup.freightFeeType === '1') {
                            if (data.freightFeePlan === '0') {
                                this.isSelected.intoCabinFee = true;
                                this.isSelected.optimizationFee = false;
                            } else {
                                this.isSelected.intoCabinFee = false;
                                this.isSelected.optimizationFee = true;
                            }
                        }
                        // ----------制单数据确认------------
                        if (data.makeBillData) {
                            this.makeBillData = data.makeBillData;
                            Object.keys(this.makeBillData).map((item) => {
                                this.makeBillData[item] = this.makeBillData[item] || '--';
                            });
                            this.makeBillData.proportion = `1:${this.makeBillData.proportion}`;
                        }
                        // 判断当前页面完成到哪里
                        this.$nextTick(() => {
                            this.scrollOptimization();// 页面滚动优化
                        });
                    },
                    complete: () => {
                        this.isLoading = false;
                    }
                });
            },
            // 返回产品货物尺寸的title
            goodsInfoTitle(goodsInfo) {
                return `${goodsInfo.length || '--'}*${goodsInfo.width || '--'}*${goodsInfo.high || '--'}/${goodsInfo.pieces || '--'}`;
            },
            // 入库数据确认按钮点击
            async intoCabinConfirm() {
                this.$bigData('入库确认点击', '入库确认点击', '1');
                // 入库数据确认 二次确认
                if (!await this.intoCabinConfirmAgain()) {
                    return;
                }

                this.isLoading = true;

                // 入库数据确认ajax 提交前提醒
                await this.intoCabinConfirmAjax('0');

                // 入库数据确认提醒弹窗
                if (this.intoCabinConfirmCallBack.goodsType.nowType !== this.intoCabinConfirmCallBack.goodsType.oldType || this.confirmTypeGroup.exceedType !== '0' || this.confirmTypeGroup.addWeightType !== '0') {
                    // 入库数据确认提醒弹窗
                    this.intoCabinConfirmTipsDialog = true;
                    this.confirmBtnType = '';
                    this.isLoading = false;
                } else {
                    // 入库数据确认ajax 提交入库数据确认
                    await this.intoCabinConfirmAjax('1');
                    // 刷新页面
                    this.$centerReload();
                }
            },
            // 入库数据确认 二次确认
            intoCabinConfirmAgain() {
                return new Promise(resolve => {
                    this.$Confirm({
                        msg: this.$t('message.toMakeIntoCabinConfirm'),
                        callback: () => {
                            resolve(true);
                        },
                        cancel: () => {
                            resolve(false);
                        }
                    });
                });
            },
            // 入库数据确认提醒弹窗 确认
            async intoCabinDialogConfirm() {
                this.intoCabinConfirmTipsDialog = false;
                this.isLoading = true;
                this.$bigData('入库确认超限选择确认类型', '入库确认超限选择确认类型', `confirmBtnType 值: ${this.confirmBtnType}  ${['1', '2'].includes(this.confirmBtnType) ? this.confirmBtnType === '1' ? '现在确认' : '稍后确认' : ''}`);
                await this.intoCabinConfirmAjax(this.confirmTypeGroup.exceedType === '0' ? '1' : this.confirmBtnType);
                // 刷新页面
                this.$centerReload();
            },
            // 入库数据确认ajax
            intoCabinConfirmAjax(type) {
                return new Promise(resolve => {
                    this.$ajax({
                        url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/DataToConfirmHandler.ashx',
                        data: {
                            act: 'postIntoCabinConfirmData',
                            orderBillCode: this.orderBillCode,
                            type: type,// 先提醒后确认 0-提交前提醒、1-提交入库数据确认（success只需返回msg: ok）、2-稍后确认
                        },
                        success: (res) => {
                            if (type === '0') {
                                // 0-提交前提醒
                                this.intoCabinConfirmCallBack = res.success;
                                resolve();
                            } else {
                                this.isLoading = false;
                                if (type === '1') {
                                    // 1-提交入库数据确认
                                    this.$Alert({
                                        msg: this.$t('message.submitSuccess'),
                                        callback: () => {
                                            resolve();
                                        }
                                    });
                                } else if (type === '2') {
                                    resolve();
                                }
                            }
                        }
                    });
                });
            },
            // 选择方案ajax
            selectSchemeAjax(type, index) {
                if (this.confirmTypeGroup.freightFeeType === '0' && !this.isSelected.optimizationFee && !this.isSelected.intoCabinFee) {
                    this.$Confirm({
                        msg: this.$t('message.toMakeSureFeeType'),
                        callback: () => {
                            this.$ajax({
                                url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/DataToConfirmHandler.ashx',
                                data: {
                                    act: 'postFreightFeeConfirmData',// 提交 运费方案
                                    orderBillCode: this.orderBillCode,// 托单号
                                    freightFeePlan: String(index),// 入库运费方案 0-默认方案、1-优化运费
                                },
                                beforeSend: () => {
                                    this.isLoading = true;
                                },
                                complete: () => {
                                    this.isLoading = false;
                                },
                                success: () => {
                                    this.isSelected[type] = true;
                                    window.location.reload();
                                }
                            });
                        }
                    });
                    this.$bigData('运费方案', '运费方案', this.orderBillCode);
                }
            },
            // 制单数据确认ajax
            makeBillDataAjax() {
                this.$Confirm({
                    msg: this.$t('message.toMakeMakeBillConfirm'),
                    callback: () => {
                        this.$ajax({
                            url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/DataToConfirmHandler.ashx',
                            data: {
                                act: 'postMakeBillConfirmData',
                                freightFeePlan: this.freightFeePlan,// 0-默认方案，1-优化方案
                                orderBillCode: this.orderBillCode
                            },
                            beforeSend: () => {
                                this.isLoading = true;
                            },
                            complete: () => {
                                this.isLoading = false;
                            },
                            success: () => {
                                this.$Confirm({
                                    msg: this.$t('message.isIntoMajorBill'),
                                    cancelButtonText: this.$t('message.forgetIt'),
                                    confirmButtonText: this.$t('message.into'),
                                    callback: () => {
                                        if (this.selectAirWaybillType === '0') {
                                            this.dialogVisible = true;
                                        } else {
                                            this.$router.push({
                                                path: '/personalCenter/PersonalCenterMain/operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillMain',
                                                query: {
                                                    orderBillCode: this.orderBillCode
                                                }
                                            });
                                        }
                                    },
                                    cancel: () => {
                                        this.$router.push('/personalCenter/PersonalCenterMain');
                                    }
                                });
                            }
                        });
                    }
                });
                this.$bigData('制单数据确认', '制单数据确认', '1');
            },
            // 页面滚动优化
            scrollOptimization() {
                // 制单数据确认完成或是都没完成
                if (this.confirmTypeGroup.makeBillType === '1' || this.confirmTypeGroup.intoCabinType === '0') {
                    return;
                }
                // 当前元素
                let el = null;
                if (this.confirmTypeGroup.freightFeeType === '1') {// 运费方案确认完成
                    el = this.$refs.billDataConfirm;
                } else if (this.confirmTypeGroup.intoCabinType === '1') {// 入库数据确认完成
                    el = this.$refs.freightPlan;
                }
                const windowHeight = this.$(window).height();// 屏幕高度
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;// 页面滚动高度
                const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;// 页面滚动宽度
                const elTop = el.getBoundingClientRect().top;// 元素对于屏幕顶部高度
                const elHeight = el.getBoundingClientRect().height;// 元素高度
                const differ = elTop - (windowHeight - elHeight) / 2;// 距离屏幕中间的高度
                window.scrollTo(scrollLeft, scrollTop + differ);
            },
            // 计算预计费用方案总费用
            computedBillListTotal(billList) {
                let total = new this.$Decimal(0);
                billList.forEach(i => {
                    total = total.add(i.totalAmount);
                });
                return total.toFixed(2);
            },

            // 获取出口主分单制作选择制单类型的数据
            getSelectAirWaybillTypeData() {
                this.orderBillCode = this.$route.query.orderBillCode;
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeBillHandler.ashx',
                    data: {
                        act: 'getSelectAirWaybillTypeData',// 获取出口主分单制作选择制单类型的数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    success: (res) => {
                        this.selectAirWaybillType = res.success.selectAirWaybillType;
                        this.maxHouseBillNumber = res.success.maxHouseBillNumber;
                        if (this.maxHouseBillNumber !== '') {
                            this.reinsuranceNumber = this.maxHouseBillNumber;
                        }
                    }
                });
            },
            // 提交出口主分单制作选择制单类型的数据
            postSelectAirWaybillTypeData(type) {
                this.orderBillCode = this.$route.query.orderBillCode;
                if (type === '0') {
                    if (this.maxHouseBillNumber !== '') {
                        if (Number(this.reinsuranceNumber > Number(this.maxHouseBillNumber))) {
                            this.$Message({
                                msg: '您输入的分单份数已超最大分单数' + this.maxHouseBillNumber + '份！'
                            });
                            return;
                        }
                    }
                    if (Number(this.reinsuranceNumber) <= 0 || !this.reinsuranceNumber) {
                        this.$Message({
                            msg: '请输入分单份数！'
                        });
                        return;
                    }
                }
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/MakeBillHandler.ashx',
                    data: {
                        act: 'postSelectAirWaybillTypeData',// 提交出口主分单制作选择制单类型的数据
                        orderBillCode: this.orderBillCode,// 托单号
                        straight: type,// 是否为直单 0-主分单出分单、1-直单/主分单不出分单
                        houseBillNumber: this.reinsuranceNumber,// 分单份数（主分单出分单才有）
                    },
                    success: () => {
                        this.dialogVisible = false;
                        this.$router.push({
                            path: '/personalCenter/PersonalCenterMain/operationCenter/cargoQuery/exportBusiness/makeBill/AirWaybillMain',
                            query: {
                                orderBillCode: this.orderBillCode
                            }
                        });
                    }
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
    .dataToConfirmBox {
        position: relative;
        box-sizing: border-box;
        width: 1070px;
        min-height: 800px;
        font-size: 16px;
        background: #fff;
    }

    .dataToConfirmBox * {
        box-sizing: border-box;
    }

    .isSelf {
        background: #f4b01c;
        border-color: #f4b01c;
    }

    .dataToConfirmBox .bookingFreight > p:nth-child(2) em {
        display: inline-block;
        width: 64px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
    }

    .dataToConfirmBox .bookingFreight .wheelingCost p:first-child em {
        display: inline-block;
        width: 70px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
    }

    .dataToConfirmBox em {
        font-style: normal;
    }

    .dataToConfirmBox > .toStoraged {
        width: 100%;
        border-bottom: 1px dashed rgba(114, 113, 113, 0.6);
    }

    .dataToConfirmBox > .toStoraged > .booking {
        display: flex;
        align-items: center;
        width: 100%;
        height: 60px;
        padding: 0 30px;
        line-height: 60px;
        background: #fff;
    }

    .dataToConfirmBox > .toStoraged > .booking > span + span {
        margin-left: 35px;
    }

    .dataToConfirmBox > .toStoraged span em:not(.unit),
    .declareWeight .kgsData,
    .docData > div span > em:not(.unit) {
        display: inline-block;
        height: 20px;
        font-size: 18px;
        font-weight: bolder;
        line-height: 20px;
        color: #00a0e9;
        text-align: center;
    }

    .dataToConfirmBox > .toStoraged span .unit,
    .declareWeight .unit,
    .docData .unit {
        display: inline-block;
        height: 15px;
        margin-left: 5px;
        font-size: 14px;
        line-height: 15px;
        text-align: center;
    }

    .dataToConfirmBox > .toStoraged > .bookingTable > table {
        width: 100%;
        border-collapse: collapse;
        border: 0;
    }

    .dataToConfirmBox > .toStoraged > .bookingTable thead > tr {
        background-color: #e3eff6;
    }

    .dataToConfirmBox > .toStoraged > .bookingTable th {
        padding: 9px 15px;
        font-size: 16px;
        font-weight: 500;
        line-height: 30px;
        color: #3e3a39;
        text-align: center;
        white-space: nowrap;
    }

    .dataToConfirmBox > .toStoraged > .bookingTable {
        overflow-x: auto;
    }

    .toStoraged > .bookingTable tbody .broken {
        color: #e83828;
    }

    .toStoraged > .bookingTable tbody > tr td {
        padding: 14px 5px;
        text-align: center;
    }

    .toStoraged > .bookingTable tbody > tr td > span {
        font-size: 14px;
    }

    .bookingTable tbody > tr td > p {
        width: 130px;
        margin: 0 auto;
        overflow: hidden;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .storageTotal > p,
    .makeDoc > .docData > p {
        width: 100%;
        height: 46px;
        padding: 0 30px;
        line-height: 46px;
        background: #f5fbfe;
    }

    .storageTotal > .storagePanel,
    .docData > .docDataBox {
        display: flex;
        justify-content: space-between;
    }

    .docData > .docDataBox div {
        line-height: 32px;
    }

    .storageTotal > .storagePanel > div,
    .docData > .docDataBox > div {
        flex-wrap: wrap;
        margin-left: 2px;
    }

    .storageTotal > .storagePanel,
    .docData > div {
        padding: 0 40px;
        font-size: 14px;
        line-height: 42px;
        background: #efefef;
    }

    .docData > .docDataBox > div > .bookingValue {
        display: block;
        white-space: nowrap;
    }

    .docData > div {
        padding: 0 45px;
    }

    .storagePanel > .empty {
        display: inline-block;
        width: 140px;
    }

    .makeDoc > .docData > div > .empty {
        display: inline-block;
        width: 60px;
    }

    .storageTotal > .storageConfirmBtn,
    .docData > .docDataConfirmBtn {
        padding: 0 60px 18px 0;
        margin-top: 20px;
        text-align: right;
        background: #fff;
    }

    .docData > .docDataConfirmBtn {
        padding: 0 60px 100px 0;
        line-height: normal;
    }

    .storageConfirmBtn /deep/ .el-button--medium,
    .docDataConfirmBtn /deep/ .el-button--medium {
        font-size: 16px;
    }

    .storageConfirmBtn /deep/ .el-button--medium.el-button--info,
    .docDataConfirmBtn /deep/ .el-button--medium.el-button--info {
        background-color: #939393;
    }

    /*********  制单数据  *********/
    .makeDoc {
        background: #fff;
    }

    .makeDoc > .declareWeight {
        padding: 30px;
    }

    .makeDoc > .scheme {
        padding-bottom: 30px;
    }

    .makeDoc > .scheme li {
        box-sizing: content-box;
        float: left;
    }

    .makeDoc > .scheme ul {
        height: 358px;
        padding: 58px 48px 58px 28px;
    }

    .makeDoc > .scheme ul > li + li {
        position: relative;
        margin-left: 40px;
        background: rgba(0, 160, 233, 0.15);
    }

    .makeDoc > .scheme ul > li + li > div {
        width: 310px;
        min-height: 160px;
        padding: 8px;
    }

    .makeDoc > .scheme ul > li + li .airPlane {
        font-size: 28px;
        color: #00a0e9;
    }

    .makeDoc .bookingFreight {
        width: 280px;
        min-height: 160px;
        padding: 7px;
    }

    .makeDoc .bookingFreight .feeNameAlign {
        vertical-align: middle;
    }

    .makeDoc .bookingFreight .bookingFreightInfo .changeColor {
        color: #f39800;
    }

    .makeDoc ul > li > div > .freightType {
        font-size: 16px;
        text-align: center;
    }

    .bookingFreight {
        .title {
            color: #f39902;
        }
    }

    .title {
        color: #00a0e9;
        text-align: center;
    }

    .cargoTypeBubbleRatio {
        display: flex;
        padding-left: 7px;
        margin-top: 10px;
        font-size: 12px;

        .bubbleRatio {
            margin-left: 24px;
        }
    }

    .feeTable {
        width: 100%;
        margin-top: 10px;
        font-size: 12px;

        th {
            padding-bottom: 8px;
            font-weight: normal;
            color: #717071;
            text-align: left;
            border-bottom: 1px dashed #bbb;

            &:first-child {
                padding-left: 7px;
            }

            &:last-child {
                padding-right: 7px;
                text-align: right;
            }
        }

        td {
            padding: 3px 0;
            color: #3e3a39;
            text-align: left;
            border-bottom: 1px dashed #bbb;

            &:first-child {
                padding-left: 7px;
            }

            &:last-child {
                padding-right: 7px;
                text-align: right;
            }
        }
    }

    .total {
        float: right;
        margin-top: 5px;
        margin-right: 7px;

        .totalCost {
            color: #f39800;
        }
    }

    .selected {
        .title {
            color: white;
        }

        .cargoTypeBubbleRatio {
            color: white;
        }

        .feeTable {
            th,
            td {
                color: white;
                border-bottom: 1px dashed white;
            }
        }

        .totalCost {
            color: #f39800;
        }
    }

    .makeDoc ul > li .freightTips {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        margin-top: 18px;
        font-size: 12px;
        color: #727171;
        text-align: left;
    }

    .makeDoc ul > li + li i + p {
        height: 24px;
        margin-top: 15px;
        line-height: 24px;
    }

    .makeDoc ul > li + li > div {
        position: relative;
        cursor: pointer;
    }

    // .makeDoc ul > li + li > div div:not(.imgIcon,.wheelingCost) {
    //     position: absolute;
    //     top: -35px;
    //     left: -17px;
    //     z-index: 10;
    //     width: 71px;
    //     height: 22px;
    //     padding-left: 6px;
    //     font-size: 14px;
    //     color: #00a0e9;
    //     border-right: 22px;
    // }

    .makeDoc .bookingFreight > p {
        font-size: 12px;
    }

    .makeDoc ul > li + li > div > .freightType i {
        font-size: 25px;
        color: #00a0e9;
    }

    .makeDoc ul > li > div > .freightType span {
        padding: 2px 2px;
        margin-left: 5px;
        color: #f39800;
    }

    .makeDoc ul > li + li > div > .freightType span {
        color: #00a0e9;
    }

    .makeDoc ul > li + li .freightTips > span {
        font-size: 12px;
    }

    .makeDoc ul > li + li > div > img {
        position: absolute;
        top: 10px;
        right: 20px;
    }

    .makeDoc ul > li + li > div > .earthIcon {
        top: 10px;
        left: 10px;
        display: block;
    }

    .makeDoc ul > li + li > div > .unSelectedIcon {
        display: none;
    }

    .makeDoc .scheme > ul > div > .selected {
        border-color: #fff;
    }

    .makeDoc ul > li .total {
        margin-top: 4px;
        font-weight: bolder;
    }

    .makeDoc .scheme > ul > li .total > em {
        font-size: 14px;
        color: #f39800;
    }

    .makeDoc .scheme > ul > li + li .total > em {
        font-size: 18px;
    }

    .makeDoc ul > li > div > .freightType + p {
        margin-top: 10px;
    }

    .makeDoc ul > li > div > p > em {
        color: #3e3a39;
    }

    .declareWeight .tips {
        font-size: 12px;
        font-weight: bolder;
        color: #e83828;
    }

    .bookingFreight .airPlane {
        font-size: 24px;
        color: #f39800;
    }

    .makeDoc .scheme > ul > .selected {
        color: #fff;
        background: rgba(0, 160, 233, 0.7);
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
    }

    .makeDoc .scheme > ul > .selected > div {
        border-color: #fff;
    }

    .scheme > .line {
        height: 0;
        margin: 0 auto;
        border-bottom: 1px dashed rgba(114, 113, 113, 0.6);
    }

    .makeDoc ul > .selected > p {
        color: #fff;
    }

    .scheme li > div .imgIcon {
        position: absolute;
        width: 21px;
        height: 21px;
    }

    .scheme > ul > li:first-child {
        background: rgba(243, 152, 0, 0.15);
    }

    .scheme li > div .imgIcon > img {
        width: 100%;
    }

    .animation {
        animation: spark 0.7s 0s linear alternate forwards infinite;
    }

    .animation1 {
        animation: spark1 0.7s 0s linear alternate forwards infinite;
    }

    @keyframes spark {
        0% {
            box-shadow: 0 0 0 #00f;
        }

        100% {
            box-shadow: 0 0 12px #00f;
        }
    }

    @keyframes spark1 {
        0% {
            box-shadow: 0 0 0 #f4b01c;
        }

        100% {
            box-shadow: 0 0 12px #f4b01c;
        }
    }

    .schemeOption {
        position: absolute;
        top: -35px;
        left: 0;
        color: #00a0e9;
    }

    .selected .schemeOption {
        color: #036eb8;
    }

    .wheelingCost {
        margin-top: 8px;
        font-size: 12px;
        color: #727171;
        text-align: center;
        background: rgba(255, 255, 255, 0.8);
    }

    .wheelingCost > p {
        line-height: 20px;
    }

    .makeDoc .scheme > ul > .selected .wheelingCost > p > * {
        color: #727171;
    }

    .makeDoc .freightType .feeTypeInfo .changeColor {
        color: #00a0e9;
    }

    .dataToConfirmBox .intoCabinConfirmTipsButtonBox {
        margin-top: 30px;
        text-align: right;
    }

    // 直单分单选择弹框
    .dialogLoad {
        .choice {
            text-align: center;

            .radio {
                display: flex;
                justify-content: space-around;

                .choiceBtn {
                    width: 116px;
                }

                .choiceBtn2 {
                    width: 116px;
                    border-left: 1px solid #dcdfe6;
                    border-radius: 4px;
                }
            }
        }

        .choiceInput {
            width: 254px;
            height: 36px;
            margin: 30px 0 0 10px;
        }
    }
</style>
